export type PausableDeadline = {
  pause: VoidFunction;
  resume: VoidFunction;
  cancel: VoidFunction;
};

type DeadlineState =
  | { status: 'paused'; remainingMs: number }
  | {
      status: 'running';
      remainingMs: number;
      resumedAt: number;
      timer: ReturnType<typeof setTimeout>;
    }
  | { status: 'done' };

export const createPausableDeadline = (
  durationMs: number,
  onExpire: VoidFunction
): PausableDeadline => {
  const deadline: { state: DeadlineState } = {
    state: { status: 'paused', remainingMs: durationMs },
  };

  const expire = () => {
    deadline.state = { status: 'done' };
    onExpire();
  };

  return {
    pause: () => {
      const { state } = deadline;
      if (state.status !== 'running') {
        return;
      }
      clearTimeout(state.timer);
      deadline.state = {
        status: 'paused',
        remainingMs: state.remainingMs - (performance.now() - state.resumedAt),
      };
    },
    resume: () => {
      const { state } = deadline;
      if (state.status !== 'paused') {
        return;
      }
      deadline.state = {
        status: 'running',
        remainingMs: state.remainingMs,
        resumedAt: performance.now(),
        timer: setTimeout(expire, Math.max(0, state.remainingMs)),
      };
    },
    cancel: () => {
      const { state } = deadline;
      if (state.status === 'running') {
        clearTimeout(state.timer);
      }
      deadline.state = { status: 'done' };
    },
  };
};
